import {
	connect
} from 'react-redux'
import CustomersComponent from '../components/CustomersComponent.jsx';
import {
	closeCustomerModal
} from '../actions';

const mapStateToProps = (state) => ({
	showModal: state.getIn(['customerReducer', 'showModal']),
})

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => {
		dispatch(closeCustomerModal());
	},
})

const CustomersContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(CustomersComponent)

export default CustomersContainer;


// WEBPACK FOOTER //
// ./src/containers/CustomersContainer.jsx